import { DateTime } from 'luxon';

export class DataType
{
    ts: DateTime;
    dp: number[];

    constructor (ts: DateTime, dp: number[])
    {
        this.ts = ts;
        this.dp = dp;
    }
}
